module.exports = __webpack_public_path__ + "img/MTN.69bc5df0.svg";